"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuContext = exports.MenuContext = void 0;
var _react = require("react");
const MenuContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.MenuContext = MenuContext;
const useMenuContext = () => {
  const data = (0, _react.useContext)(MenuContext);
  if (!data) {
    throw new Error("useMenuContext must be used within a Menu component");
  }
  return data;
};
exports.useMenuContext = useMenuContext;